import css from './tabs.module.css'
import { ITab } from './tabs.types'
import cn from '../../utils/cn.ts'
import { CSSProperties } from 'react'
import PlusIcon from '@/assets/icons/plus.svg?react'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'

interface IProps {
  tabs: ITab[]
  onSelect: (tab: ITab['id']) => void
  selectedTab: ITab['id']

  className?: string
  textClassname?: string
  style?: CSSProperties
  tabStyle?: CSSProperties

  withCreate?: boolean
  onCreate?: () => Promise<void>
}

const Tabs = (props: IProps) => {
  const { wait: waitCreate, loading: createLoading } = useHttpLoader()
  const handleTabSelect = (id: ITab['id']) => () => props.onSelect(id)

  const renderTabs = () => {
    return props.tabs.map((tab) => (
      <div
        style={props.tabStyle}
        className={css.tab}
        key={tab.id.toString()}
        data-selected={props.selectedTab === tab.id}
        onClick={handleTabSelect(tab.id)}
      >
        {typeof tab.title === 'string' ? (
          <span className={props.textClassname || 'text-nm'} style={{ color: 'inherit' }}>
            {tab.title}
          </span>
        ) : (
          tab.title
        )}
        {Boolean(tab.actionIcon) && (
          <div
            className={css.actionIcon}
            onClick={(ev) => {
              ev.stopPropagation()

              if (tab.onActionClick) {
                tab.onActionClick()
              }
            }}
          >
            {tab.actionIcon}
          </div>
        )}
      </div>
    ))
  }

  const className = props.className ? cn(props.className, css.wrapper) : css.wrapper

  return (
    <div className={className} style={props.style}>
      {renderTabs()}
      {props.withCreate && (
        <Button
          size="default"
          type="default"
          icon={<PlusIcon />}
          loading={createLoading}
          onClick={() => waitCreate(props.onCreate())}
        />
      )}
    </div>
  )
}

export default Tabs
